import { Table, TableBody, TableCell, TableHead, TableRow, Paper, TablePagination, TextField, Box, } from "@mui/material";
import React, { useState } from "react";

export default function MPMetalSheetTable({ rows, onSearchChange, searchValue: searchValueProp }) {

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [searchValue, setSearchValue] = useState(searchValueProp ?? "");

    const handleChangePage = (_, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSearchChange = (event) => {
        const value = event.target.value;
        setSearchValue(value);
        if (onSearchChange) onSearchChange(value);
    };

    const paginatedRows = rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);


    return (

        <Paper
            sx={{
                borderRadius: "4px",
                p: 2,
                overflow: "hidden",
                maxWidth: "100%",
            }}
        >
            <Box sx={{ p: 2, display: "flex", justifyContent: "flex-end", borderRadius: 4 }}>
                <TextField
                    variant="outlined"
                    size="small"
                    placeholder="Procurar..."
                    value={searchValue}
                    onChange={handleSearchChange}
                    sx={{
                        width: 250,
                        "& .MuiOutlinedInput-root": {
                            borderRadius: "12px",
                            transition: "all 0.2s ease-in-out",
                            "&:hover fieldset": { borderColor: "var(--text-primary)" },
                            "&.Mui-focused fieldset": { borderColor: "var(--color-primary)" },
                        },
                        "& .MuiInputBase-input": { color: "var(--text-primary)" },
                        "& .MuiInputLabel-root.Mui-focused": { color: "var(--text-primary)" },
                    }}
                />
            </Box>
            <Table sx={{ minWidth: 900, borderCollapse: "collapse" }}>
                <TableHead>
                    <TableRow sx={{ "& th": { border: "1px solid var(--border-color)", textAlign: "center", fontWeight: "bold", fontSize: "0.85rem", px: 0.5, py: 1 } }}>
                        <TableCell colSpan={2}>Steel grade</TableCell>
                        <TableCell>Usual delivery condition</TableCell>
                        <TableCell>Nominal thickness t</TableCell>
                        <TableCell colSpan={3}>Tensile properties at room temperature</TableCell>
                        <TableCell colSpan={3}>Impact energy KV2 J min. at a temperature in °C</TableCell>
                    </TableRow>
                    <TableRow sx={{ "& th": { border: "1px solid var(--border-color)", textAlign: "center", fontWeight: "bold", fontSize: "0.85rem", px: 0.5, py: 1 } }}>
                        <TableCell>Steel name</TableCell>
                        <TableCell>Steel number</TableCell>
                        <TableCell></TableCell>
                        <TableCell>mmm</TableCell>
                        <TableCell>Yield strength ReH (MPa min)</TableCell>
                        <TableCell>Tensile strength Rm (MPa)</TableCell>
                        <TableCell>Elongation after fracture A% min</TableCell>
                        <TableCell>-20°</TableCell>
                        <TableCell>0°</TableCell>
                        <TableCell>+20°</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {paginatedRows.map((row, rowIndex) => (
                        <React.Fragment key={rowIndex}>
                            {row.properties.map((property, propIndex) => (
                                <TableRow
                                    key={propIndex}
                                    sx={{ "& td, & th": { border: "1px solid var(--border-color)", textAlign: "center" } }}
                                >
                                    {propIndex === 0 && (
                                        <TableCell rowSpan={row.properties.length}>
                                            {row.steelName}
                                        </TableCell>
                                    )}

                                    {propIndex === 0 && (
                                        <TableCell rowSpan={row.properties.length}>
                                            {row.steelNumber}
                                        </TableCell>
                                    )}

                                    {propIndex === 0 && (
                                        <TableCell rowSpan={row.properties.length}>
                                            {row.deliveryCondition}
                                        </TableCell>
                                    )}

                                    <TableCell>{property.nominalThicknessTMm}</TableCell>
                                    <TableCell>{property.yieldStrengthReHMpaMin}</TableCell>
                                    <TableCell>{property.tensileStrengthRmMpa}</TableCell>
                                    <TableCell>{property.elongationAPercentMin}</TableCell>
                                    <TableCell>{property.impactEnergyKv2JAtMinus20C}</TableCell>
                                    <TableCell>{property.impactEnergyKv2JAt0C}</TableCell>
                                    <TableCell>{property.impactEnergyKv2JAtPlus20C}</TableCell>
                                </TableRow>
                            ))}
                        </React.Fragment>
                    ))}
                </TableBody>
            </Table>
            <TablePagination
                component="div"
                count={rows.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[5, 10, 25]}
            />
        </Paper>
    );
}
